import { useMemo } from 'react';
import { useProjectContext, type ProjectContext } from '@atlassian/jira-providers-project-context';

const generateValues = (value: string): Array<string> => {
	const lowerValue = value.toLowerCase();
	return [lowerValue, `"${lowerValue}"`, `'${lowerValue}'`];
};

// exported to create mock Data
export const createValues = (
	projectKey: string | undefined,
	projectContext: Pick<ProjectContext, 'projectKey' | 'projectId' | 'projectName'> | null,
): Set<string> | null => {
	if (projectKey == null) {
		return null;
	}
	if (projectContext?.projectKey !== projectKey) {
		return new Set([...generateValues(projectKey)]);
	}
	return new Set([
		...generateValues(projectKey),
		...generateValues(String(projectContext.projectId)),
		...generateValues(projectContext.projectName),
	]);
};

export const useGetProjectJQLValues = (projectContext?: string) => {
	const projectRRR = useProjectContext();
	return useMemo<Set<string> | null>(() => {
		return createValues(
			projectContext,
			projectRRR.data == null
				? null
				: {
						projectId: projectRRR.data.projectId,
						projectKey: projectRRR.data.projectKey,
						projectName: projectRRR.data.projectName,
					},
		);
	}, [projectContext, projectRRR]);
};
